// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__36QZR","colMin":"styles_colMin__cBd0G","colCheckbox":"styles_colCheckbox__51aPm"};